export default __webpack_public_path__ + "static/media/game-pagetype-not_started_game.821f31be.svg";